import { GetRolesParams, RolesResponse } from "@/types";
import { apiFetch } from "../fetch";
import { getAccessToken } from "@/utils";

export async function getRoles(
  params?: GetRolesParams,
): Promise<RolesResponse> {
  const queryParams = new URLSearchParams();

  if (params) {
    if (params.type) {
      queryParams.append("type", params.type);
    }
    if (params.name) {
      queryParams.append("name", params.name);
    }
    if (params.resource_type) {
      queryParams.append("resource_type", params.resource_type);
    }
    if (params.resource_id) {
      queryParams.append("resource_id", params.resource_id);
    }
    if (params.include_instance_scoped !== undefined) {
      queryParams.append(
        "include_instance_scoped",
        params.include_instance_scoped.toString(),
      );
    }
    if (params.permission) {
      queryParams.append("permission", params.permission);
    }
    if (params.page !== undefined) {
      queryParams.append("page", params.page.toString());
    }
    if (params.limit !== undefined) {
      queryParams.append("limit", params.limit.toString());
    }
    if (params.order) {
      queryParams.append("order", params.order);
    }
  }

  const queryString = queryParams.toString();
  const url = `/roles${queryString ? `?${queryString}` : ""}`;

  return apiFetch<RolesResponse>(url, {
    method: "GET",
    token: getAccessToken(),
    headers: {
      "x-saasbase-project-id": "proj_06fghx60hnrcxftadsj44e0pj8",
    },
  });
}
